module.exports = "<div class=\"outer-loader-small\">\r\n  <div class=\"lds-circle-small\"><div></div><p>loading..</p></div> \r\n</div>"